import { DateTime } from 'luxon';
import { transformToCurrency } from './const';

export function formatPartialOrderHash(hash: string) {
  return hash.slice(0, 2) + hash.slice(-2);
}

export function determinateDaysAgo(date: number | string) {
  const now = new Date();
  const orderDate = new Date(date);
  const diffTime = Math.abs(now.getTime() - orderDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export function formatDateToShort(input: string): string {
  const date = new Date(input);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = String(date.getUTCFullYear()).slice(-2);

  return `${day}/${month}/${year}`;
}

export function convertToZone(fechaStr: string, format: string = 'dd/MM/yyyy HH:mm', zone: string = 'America/Bogota',): string {
  const fechaUTC = DateTime.fromFormat(fechaStr, format, { zone: 'UTC' });
  const fechaColombia = fechaUTC.setZone(zone);
  return fechaColombia.toFormat(format);
}

export const formatCOP = (value: number, isDollar: boolean = false): string => {
  const formatted = value.toFixed(2);
  const [whole, decimal] = formatted.split('.');
  const formattedWhole = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  const result = `${formattedWhole}${decimal === '00' ? '' : ',' + decimal}`;

  if (isDollar) {
    return transformToCurrency(Number(value));
  }

  return `$${result}`;
}

// formate date to string to yyyy-mm-dd hh:mm:ss
export const formatDateToISOString = (date: Date): string => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};